import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

import "@/assets/App.scss";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

import YmapPlugin from "vue-yandex-maps";
Vue.use(YmapPlugin);

import { yandexMap, ymapMarker } from "vue-yandex-maps";
Vue.component("yandexMap", yandexMap);
Vue.component("ymapMarker", ymapMarker);

/*delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
*/
import axios from "axios";

axios.defaults.baseURL = "https://tagproject-api.sfedu.ru/";

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";

import JsonCSV from "vue-json-csv";

Vue.component("downloadCsv", JsonCSV);

import VueCookies from "vue-cookies";

Vue.use(VueCookies, { expire: "7d" });

new Vue({
  axios,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
